import { Typography } from '@material-ui/core';

import {
  MetricsTableErrorFragment,
  MetricsV1TableState,
} from '@spotify/confidence-graphql';

import {
  formatTableError,
  tableStateIcon,
  tableStateLabel,
} from './TableState';

export const TableStateMui = ({
  status,
  error,
}: {
  status: MetricsV1TableState;
  error: Maybe<MetricsTableErrorFragment> | undefined;
}) => {
  const Status = tableStateIcon(status);
  return (
    <Typography title={formatTableError(error)} noWrap component="div">
      <Status>
        <Typography variant="body2" component="span">
          {tableStateLabel(status)}
        </Typography>
      </Status>
    </Typography>
  );
};
